<script setup lang="ts">
import { ComboboxInput, type ComboboxInputProps, useForwardProps } from 'radix-vue'
import { type HTMLAttributes, computed } from 'vue'

import { Icon } from '@/ui'
import { cn } from '@/utils'

defineOptions({
  inheritAttrs: false,
})

const props = withDefaults(
  defineProps<
    ComboboxInputProps & {
      class?: HTMLAttributes['class']
      wrapperClass?: string
      iconClass?: string
    }
  >(),
  {
    autoFocus: true,
    class: '',
    wrapperClass: '',
    iconClass: '',
  }
)

const delegatedProps = computed(() => {
  const { class: _, wrapperClass: _w, iconClass: _i, ...delegated } = props

  return delegated
})

const forwardedProps = useForwardProps(delegatedProps)
</script>

<template>
  <div :class="cn('flex items-center border-b px-3', wrapperClass)" cmdk-input-wrapper>
    <Icon name="MagnifyingGlassIcon" :class="cn('mr-2 size-4 shrink-0 opacity-50', iconClass)" />
    <ComboboxInput
      v-bind="{ ...forwardedProps, ...$attrs }"
      tabindex="-1"
      :class="
        cn(
          'placeholder:text-muted-foreground flex h-11 w-full rounded-md bg-transparent py-3 text-sm outline-hidden disabled:cursor-not-allowed disabled:opacity-50',
          props.class
        )
      "
    />
  </div>
</template>
